import { GetRequest } from "../../hook/useRequest";
import { AppSettings } from "../../AppSettings";
import { getToken } from "../../utils/storage/Token";

export type ArchiveType = "BUSINESS" | "BL" | "BILLING" | "EXPENSE" | "OUTLAY_ITEM";

const API_URL_ARCHIVE = AppSettings.API_FREELANCERIE + "/archive";

/**
 * Vérifie si un fichier d'archive existe déjà pour le contexte donné.
 * @param type type d'archive
 * @param id identifiant de l'entité
 * @returns true si une archive existe déjà
 */
const CheckArchiveExists = async (type: ArchiveType, id: number): Promise<boolean> => {
    const config = { headers: { Authorization: getToken() } };
    const res = await GetRequest(`${API_URL_ARCHIVE}/exists/${type}/${id}`, config);
    return res.data?.exists === true;
};

export { CheckArchiveExists };
